<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <template v-if="sentMessage">
          <div class="popup-full__content">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../../assets/img/resume-popups/response.svg" :alt="$tVacancy('Apply for job')">
              </picture>
            </div>
            <h3 class="popup-full__title">{{sentMessage}}</h3>
            <BaseAlert :value="overallErrorsMix"
                       class="popup-full__error  _warning"/>
            <div class="popup-full__buttons" style="margin-top: 2rem">
              <button type="button"
                      @click="close"
                      class="popup-full__btn  base-btn base-btn--green">
                <span>{{ $tVacancy('Ok') }}</span>
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="popup-full__content">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../../assets/img/resume-popups/response.svg" :alt="$tVacancy('Apply for job')">
              </picture>
            </div>
            <h3 class="popup-full__title">{{ $tVacancy('Notify about new vacancies') }}</h3>
            <div class="popup-full__text text">
              <p>{{ $tVacancy('Notify description') }}</p>
            </div>
            <BaseAlert :value="overallErrorsMix"
                       class="popup-full__error  _warning"/>
            <div class="popup-full__buttons">
              <button type="button"
                      @click="onSubscribeClick"
                      class="popup-full__btn  base-btn base-btn--green">
                <span>{{ $tVacancy('Notify') }}</span>
                <BasePreloader v-if="pendingButton"/>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from "../../axios"
  import formMixins from "../../mixins/formMixins"

  export default {
    mixins: [formMixins],
    props: {
      vacancyId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        pendingButton: false,
        sentMessage: null,
      }
    },
    methods: {
      close() {
        this.$vModal.close('subscribe-on-vacancy')
      },
      onSubscribeClick() {
        if (!this.vacancyId) return
        this.pendingButton = true
        this.sentMessage = null
        this.resetErrorsMix()

        http.post(`api/new-vacancy/send-me-notification/${this.vacancyId}`).then(({data}) => {
          this.sentMessage = data.message
          this.close()
        }).catch(this.errorHandlerMix)
            .finally(() => {
              this.pendingButton = false
            })
      },
    }
  }
</script>

<style lang="less">

</style>
